import ViewAndDownloadFileStatsModal from './ViewAndDownloadFileStatsModal.component';

export default ViewAndDownloadFileStatsModal;
